"use strict";
var throwIfEmpty_1 = require('../operators/throwIfEmpty');
function throwIfEmpty(errorFactory) {
    if (errorFactory === void 0) { errorFactory = throwIfEmpty_1.defaultErrorFactory; }
    return throwIfEmpty_1.throwIfEmpty(errorFactory)(this);
}
exports.throwIfEmpty = throwIfEmpty;
//# sourceMappingURL=throwIfEmpty.js.map